import { put, call, takeEvery, takeLatest, all, delay } from "redux-saga/effects"

import Actions from "../Actions/Creators"
import Types from "../Actions/Types"

import Phi from "../Phi/Phi"
import Constants from "../Phi/Constants"

function* sendEmail(action) {
    const { template, recipients, variables, subject } = action

    let parameters = {
        queue: "mail-subscribe",
        payload: {
            template: template,
            recipients: recipients,
            vars: variables,
            subject: subject || null,
        },
    }

    const response = yield call(Phi.Communication.makeACall, Phi.Communication, parameters)

    if (response) {
    } else {
    }
}

function* makeCall(action) {
    const { numberTo, numberFrom } = action

    const CALL_PARAMS = Constants.communicationMap.CALL.DEFAULT_PARAMS

    let parameters = {
        queue: "call-subscribe",
        payload: { 
            To: numberTo, 
            From: numberFrom, 
            CallerId: CALL_PARAMS.CallerId 
        }
    }

    const response = yield call(Phi.Communication.makeACall, Phi.Communication, parameters)

    if (response) {
    } else {
    }
}

function* sendOTP(action) {
    const { phone, email, userId } = action

    const response = yield call(Phi.Communication.sendOtp, Phi.Communication, {
        phone: phone,
        email: email,
        userId: userId,
        length: 4
    });

    if (response) {
        // yield put(Actions.responseSendOtp({ ok: true }));
    } else {
        // yield put(Actions.responseSendOtp({ ok: false }));
    }
}

// Saga Watcher
export function* watchCommunicationActions() {
    yield* [
        takeEvery(Types.SEND_EMAIL, sendEmail),
        takeEvery(Types.MAKE_CALL, makeCall),
        takeEvery(Types.SEND_OTP, sendOTP),
    ]
}
